export const SET_PAGINATION_COMPANY_SERVICE = 'SET_PAGINATION_COMPANY_SERVICE';
export const CLEAR_PAGINATION_COMPANY_SERVICE = 'CLEAR_PAGINATION_COMPANY_SERVICE';

export const setPaginationCompanyService = payload => ({
  type: SET_PAGINATION_COMPANY_SERVICE,
  payload,
});

export const clearPaginationCompanyService = payload => ({
  type: CLEAR_PAGINATION_COMPANY_SERVICE,
  payload,
});
